<template lang="pug">
section.src-components-cajas-toolbar
  v-btn.ma-2.mx-2(fab dark small color="teal" :disabled="loading" @click="excel()") #[v-icon(dark) mdi-microsoft-excel]
  v-btn.ma-3(small @click="db_update()" color="secondary" dark) #[v-icon mdi-update] Actualizar 
</template>

<script lang="js">
  import { EventBus } from '@/event-bus';
  export default  {
    name: 'src-components-cajas-toolbar',
    props: [],
    mounted () {

    },
    data () {
      return {

      }
    },
    methods: {
      db_update() {
        EventBus.$emit('toolbar_click','update');
      },
      excel() {
        EventBus.$emit('toolbar_click','excel');
      }      
    },
    computed: {

    }
}


</script>

<style scoped lang="scss">
  .src-components-cajas-toolbar {
    
  }
</style>
